// Copyright (c) StrangeBee 2024

import React, { ReactElement } from 'react';
import { Button } from 'antd';
import { ICONS } from '@Constants/iconsApp';

interface AddItemButtonProps {
    onClick?: () => void;
}

const AddItemButton = ({ onClick }: AddItemButtonProps): ReactElement => (
    <Button onClick={onClick} type="dashed" icon={<ICONS.PlusIcon />} shape="circle" size="small" />
);

export default AddItemButton;
